import type { ClientEnv } from "../.env.schema";

export const clientEnv = import.meta.env as unknown as ClientEnv;
